// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3B3GP","requiredAsterisk":"Info_requiredAsterisk__1Addc"};